/* eslint-disable no-console */
import { Value } from "@sinclair/typebox/value";
import { TObject } from "@sinclair/typebox";

export function checkSettingsSchema(settings: object, schema: TObject): object {
    const errors = Array.from(Value.Errors(schema, settings));

    if (errors.length === 0) {
        return settings;
    }

    // trying to apply defaults first
    let clone = Value.Clone(settings);
    clone = Value.Default(schema, clone) as object;
    const cloneErrors = Array.from(Value.Errors(schema, clone));
    if (cloneErrors.length === 0) {
        console.warn("Default settings applied, resulting settings:\n", clone);
        return clone;
    }

    console.error("Found the following errors in the settings:");
    for (const error of errors) {
        console.error(
            `Path: ${error.path}, Value: ${String(error.value)}, Error: ${error.message}\n`,
        );
        if (error.schema.default !== undefined) {
            console.log("Default value: ", error.schema.default);
        }
        console.groupCollapsed("Schema");
        console.log(error.schema);
        console.groupEnd();
    }
    console.error("Trying to fix...");
    try {
        settings = Value.Parse(schema, settings);
    } catch (e) {
        console.error("Failed to fix the settings: ", (e as Error).message);
    }
    console.error("Resulting settings:\n", settings);
    return settings;
}
